import { Fragment } from 'react'

import './Embroidery.scss'

import { data } from '../../data/embroidery_data'

import { slugify, getEmbroideryImages } from '../../helpers/helpers'

const Embroidery = ({
    addEmbroidery,
    setAddEmbroidery,
    productOptions,
    handleOptions,
    clearOptions,
    productHandle,
}) => {
    const embroideryData = data.embroidery

    // console.log('embroideryData', embroideryData, productHandle)

    console.log('productOptions', productOptions)

    const embroideryProducts = embroideryData.products

    let embroideryFonts = []
    let embroideryThreadColors = embroideryData.threads

    let embroideryProduct = embroideryProducts.filter((p) => {
        return p.productHandle === productHandle
    })

    console.log('embroideryProduct', embroideryProduct)

    if (!embroideryProduct || embroideryProduct.length === 0) {
        return null
    }

    // const characterLimit = embroideryProduct[0].characterLimit

    // console.log('characterLimit', characterLimit)

    const embroideryTypes = embroideryProduct[0].embroideryTypes

    console.log('embroideryTypes', embroideryTypes)

    embroideryFonts = embroideryProduct[0].fonts

    embroideryFonts = embroideryFonts.filter((f) => {
        return f.active
    })

    let characterLimit

    console.log('embroideryProduct here', embroideryProduct[0])

    if (productOptions.embroideryCharacterLimit) {
        characterLimit = productOptions.embroideryCharacterLimit
    } else {
        characterLimit = 20
    }

    console.log('characterLimit in Embroidery.js', characterLimit)

    // console.log('embroideryProduct', embroideryProduct, embroideryFonts)

    const fontImages = getEmbroideryImages()

    const map = new Map()
    embroideryFonts.forEach((item) => map.set(item.webName, item))
    fontImages.forEach((item) =>
        map.set(item.webName, { ...map.get(item.webName), ...item })
    )
    let mergedEmbroideryArray = Array.from(map.values())

    // mergedEmbroideryArray.unshift(mamaImage)

    console.log('merged Array', mergedEmbroideryArray)

    const colors = embroideryProduct[0].colors

    // console.log('colors', colors)

    let threadColors

    if (colors && colors.length > 0) {
        threadColors = embroideryThreadColors.filter((el) => {
            return colors.some((f) => {
                return f.name === el.name
            })
        })
    } else {
        threadColors = embroideryThreadColors
    }

    // console.log('threadColors', threadColors)

    console.log('productOptions', productOptions)

    if (productOptions && productOptions.embroideryType && productOptions.embroideryType.mama) {
        mergedEmbroideryArray = mergedEmbroideryArray.map((f) => {
            if (f.webName === 'Classic Cursive') {
                f.active = false
            }
            return f
        })
    }

    const verifyProductOptions = (productOptions) => {
        const options = productOptions
        // const types = productOptions.embroideryType

        // let hasType = Object.values(types).some((v) => v === true)

        return (
            options &&
            options.embroideryColor.threadColor &&
            options.embroideryColor.name &&
            options.embroideryFont.webName &&
            options.embroideryFont.fontName &&
            options.embroideryText
            // options.embroideryText.length <= characterLimit &&
            // hasType
        )
    }

    let verified = verifyProductOptions(productOptions)

    // console.log('verified', verified)

    return (
        <div
            id="pdp-embroidery"
            className={`embroidery-outer ${
                productOptions.embroidery ? 'embroidery-open' : ''
            }`}
        >
            <div className="embroidery-inner">
                <div className="embroidery-heading">
                    <h3>Embroidery</h3>
                </div>
                <div className="embroidery-options">
                    <div className="embroidery-option add-embroidery">
                        <label htmlFor="addEmbroidery">
                            <input
                                checked={productOptions.embroidery}
                                type="checkbox"
                                id="addEmbroidery"
                                name="addEmbroidery"
                                onChange={(e) => handleOptions(e)}
                            />{' '}
                            Add Embroidery?&nbsp;
                            {productOptions.embroidery ? (
                                <span className="embroidery-added">Yes</span>
                            ) : null}
                        </label>
                    </div>
                    {productOptions.embroidery ? (
                        <Fragment>
                            {/* <div className="embroidery-option embroidery-type">
                                <h3 className="option-heading">
                                    Embroidery Type (choose one)
                                    <span className="required">*</span>
                                </h3>
                                <div className="embroidery-type-options">
                                    {embroideryTypes.map((type) => {
                                        if (type === 'Cursive Initials') {
                                            return (
                                                <div className="embroidery-type-option">
                                                    <input
                                                        checked={
                                                            productOptions
                                                                .embroideryType
                                                                .monogram
                                                        }
                                                        type="radio"
                                                        id="embroideryTypeMonogram"
                                                        name="embroideryTypeMonogram"
                                                        onChange={(e) =>
                                                            handleOptions(e)
                                                        }
                                                    />
                                                    <label htmlFor="embroideryTypeMonogram">
                                                        Cursive Initials
                                                    </label>
                                                </div>
                                            )
                                        }
                                        if (type === 'Mama') {
                                            return (
                                                <div className="embroidery-type-option">
                                                    <input
                                                        checked={
                                                            productOptions
                                                                .embroideryType
                                                                .mama
                                                        }
                                                        type="radio"
                                                        id="embroideryTypeMama"
                                                        name="embroideryTypeMama"
                                                        onChange={(e) =>
                                                            handleOptions(e)
                                                        }
                                                    />
                                                    <label htmlFor="embroideryTypeMama">
                                                        Mama
                                                    </label>
                                                </div>
                                            )
                                        }
                                        if (type === 'Text') {
                                            return (
                                                <div className="embroidery-type-option">
                                                    <input
                                                        checked={
                                                            productOptions
                                                                .embroideryType
                                                                .text
                                                        }
                                                        type="radio"
                                                        id="embroideryTypeText"
                                                        name="embroideryTypeText"
                                                        onChange={(e) =>
                                                            handleOptions(e)
                                                        }
                                                    />
                                                    <label htmlFor="embroideryTypeText">
                                                        Text
                                                    </label>
                                                </div>
                                            )
                                        }
                                        if (type === 'Single') {
                                            return (
                                                <div className="embroidery-type-option">
                                                    <input
                                                        checked={
                                                            productOptions
                                                                .embroideryType
                                                                .single
                                                        }
                                                        type="radio"
                                                        id="embroideryTypeSingle"
                                                        name="embroideryTypeSingle"
                                                        onChange={(e) =>
                                                            handleOptions(e)
                                                        }
                                                    />
                                                    <label htmlFor="embroideryTypeSingle">
                                                        Single Letter
                                                    </label>
                                                </div>
                                            )
                                        }
                                        return null
                                    })}
                                </div>
                            </div> */}
                            <div
                                className={`embroidery-option embroidery-text-input`}
                            >
                                <label htmlFor="embroideryText">
                                    Embroidery Text*{' '}
                                    <span>{`(max ${characterLimit} characters)`}</span>
                                </label>


                                    <input
                                        value={productOptions.embroideryText}
                                        type="text"
                                        id="embroideryText"
                                        name="embroideryText"
                                        maxLength={characterLimit}
                                        onChange={(e) => handleOptions(e)}
                                    />


                                <p className="embroidery-text-example">
                                Characters are case sensitive. Please enter the text exactly as you would like it to appear.
                                </p>
                            </div>
                            <div
                                className={`embroidery-option embroidery-fonts`}
                            >
                                <h3 className="option-heading">
                                    Font
                                    {productOptions.embroideryFont &&
                                    productOptions.embroideryFont.webName
                                        ? ': ' +
                                          productOptions.embroideryFont.webName
                                        : ''}
                                </h3>
                                <ul className="nostyle fonts-list">
                                    {mergedEmbroideryArray.map((f) => {
                                        // console.log('f', f)
                                        let fontImage
                                        if (f.image && f.image.default) {
                                            fontImage = f.image.default
                                        }
                                        // console.log('fontImage', fontImage)
                                        return (
                                            <li
                                                key={
                                                    f.webName +
                                                    '-' +
                                                    productHandle
                                                }
                                                className={`${f.slug} ${
                                                    f.active
                                                        ? 'font-active'
                                                        : 'font-disabled'
                                                }`}
                                            >
                                                <div
                                                    className={`font-image ${
                                                        productOptions.embroideryFont &&
                                                        productOptions
                                                            .embroideryFont
                                                            .webName ===
                                                            f.webName
                                                            ? 'font-selected'
                                                            : ''
                                                    }`}
                                                    aria-label={f.webName}
                                                    data-balloon-pos="up"
                                                >
                                                    {fontImage ? (
                                                        <img
                                                            src={fontImage}
                                                            alt={
                                                                f.webName +
                                                                ' font sample'
                                                            }
                                                            data-option="embroideryFont"
                                                            onClick={(e) =>
                                                                handleOptions(
                                                                    e,
                                                                    f
                                                                )
                                                            }
                                                        />
                                                    ) : null}
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className="embroidery-option embroidery-colors">
                                <h3 className="option-heading">
                                    Thread Color
                                    {productOptions.embroideryColor &&
                                    productOptions.embroideryColor.name
                                        ? ': ' +
                                          productOptions.embroideryColor.name
                                        : ''}
                                </h3>
                                <ul className="nostyle colors-list">
                                    {threadColors &&
                                        threadColors.map((c) => {
                                            return (
                                                <li key={c.hex}>
                                                    <div
                                                        className={`color-image ${
                                                            productOptions.embroideryColor &&
                                                            productOptions
                                                                .embroideryColor
                                                                .name === c.name
                                                                ? 'color-selected'
                                                                : ''
                                                        }`}
                                                        style={{
                                                            backgroundColor:
                                                                c.hex,
                                                        }}
                                                        aria-label={c.name}
                                                        data-balloon-pos="up"
                                                        onClick={(e) =>
                                                            handleOptions(e, c)
                                                        }
                                                        data-option="embroideryColor"
                                                    ></div>
                                                </li>
                                            )
                                        })}
                                </ul>
                            </div>

                            <div className="options-summary">
                                <h3 className="option-heading">
                                    Options Summary
                                </h3>
                                <div className="options-summary-content">
                                    <ul className="nostyle options-summary-list">
                                        <li>
                                            Embroidery Type:{' '}
                                            {productOptions.embroideryType ? (
                                                <Fragment>
                                                    {productOptions
                                                        .embroideryType
                                                        .monogram === true ? (
                                                        <span className="option-selected">
                                                            Cursive Initials
                                                        </span>
                                                    ) : productOptions
                                                          .embroideryType
                                                          .text === true ? (
                                                        <span className="option-selected">
                                                            Text
                                                        </span>
                                                    ) : productOptions
                                                          .embroideryType
                                                          .mama === true ? (
                                                        <span className="option-selected">
                                                            Mama
                                                        </span>
                                                    ) : null}
                                                </Fragment>
                                            ) : (
                                                <span className="missing-option">
                                                    No text provided.
                                                </span>
                                            )}
                                        </li>
                                        <li>
                                            Embroidery Text:{' '}
                                            {productOptions.embroideryText ? (
                                                <span className="option-selected">
                                                    {`"${productOptions.embroideryText}"`}
                                                </span>
                                            ) : (
                                                <span className="missing-option">
                                                    No text provided.
                                                </span>
                                            )}
                                        </li>
                                        <li>
                                            Font:{' '}
                                            {productOptions.embroideryFont
                                                .webName ? (
                                                <span className="option-selected">
                                                    {
                                                        productOptions
                                                            .embroideryFont
                                                            .webName
                                                    }
                                                </span>
                                            ) : (
                                                <span className="missing-option">
                                                    No font selected.
                                                </span>
                                            )}
                                        </li>
                                        <li>
                                            Color:{' '}
                                            {productOptions.embroideryColor
                                                .name ? (
                                                <span className="option-selected">
                                                    {
                                                        productOptions
                                                            .embroideryColor
                                                            .name
                                                    }
                                                </span>
                                            ) : (
                                                <span className="missing-option">
                                                    No color selected.
                                                </span>
                                            )}
                                        </li>
                                        <li>
                                            Price:{' '}
                                            {productOptions.embroideryPrice ? (
                                                <span className="option-selected">
                                                    {'$' +
                                                        productOptions.embroideryPrice.toFixed(
                                                            2
                                                        )}
                                                </span>
                                            ) : (
                                                <span className="missing-option">
                                                    Price will be determined by
                                                    selected options.
                                                </span>
                                            )}
                                            {/* <span>Free</span> */}
                                        </li>
                                        <li>
                                            Submitted:{' '}
                                            {productOptions.embroiderySubmitted ? (
                                                <span className="option-selected">
                                                    {
                                                        productOptions.embroiderySubmitted
                                                    }
                                                </span>
                                            ) : (
                                                <span className="missing-option">
                                                    Not yet submitted.
                                                </span>
                                            )}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="embroidery-option embroidery-price">
                                <h3 className="option-heading">
                                    Options Additional Price:{' '}
                                    <span className="price">$15.00</span>
                                </h3>
                            </div>
                            <div className="submit-options">
                                <button
                                    className={`btn button secondary-button large-button clear-button`}
                                    onClick={(e) => clearOptions(e)}
                                    aria-label="All selected options will be cleared. Are you sure?"
                                    data-balloon-pos="up"
                                >
                                    Clear Options
                                </button>
                                <button
                                    className={`btn button primary-button large-button ${
                                        verified ? '' : 'disabled'
                                    } ${
                                        productOptions.embroiderySubmitted
                                            ? 'disabled'
                                            : null
                                    }`}
                                    aria-label={
                                        verified
                                            ? `${
                                                  productOptions.embroiderySubmitted
                                                      ? 'Emboridery options have been submitted. Please add your item to your cart.'
                                                      : 'Submit embroidery options.'
                                              }`
                                            : 'Please select all required options.'
                                    }
                                    data-balloon-pos="up"
                                    data-option="embroiderySubmitted"
                                    onClick={
                                        verified
                                            ? (e) => handleOptions(e)
                                            : null
                                    }
                                >
                                    Submit Options
                                </button>
                            </div>
                        </Fragment>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default Embroidery
